module.exports = __webpack_public_path__ + "static/scale-model-of-visit-sandy-springs-in-sandy-springs-georgia-cf36c052915e5039819e4576a045ea3f.png";